import { 
  getAgoraToken,
  getAgoraChatToken,
  markBookedEventLog 
} from 'src/consumer/services/featureServices'
import { allAvailableEventTypes } from 'src/consumer/constants'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { AGORA_RTC_LAYOUTS, AGORA_RTC_LEGACY_LAYOUT_IDS } from 'src/live'

export const agoraService = {
  // Get Agora RTC tokens
  async getAgoraTokens(bookedEventId, isHost) {
    const [response, responseScreen] = await Promise.all([
      getAgoraToken(bookedEventId, isHost),
      getAgoraToken(bookedEventId, isHost)
    ])

    if (
      response?.status === 200 &&
      isCommonResponseSuccessful(response?.data?.code) &&
      response?.data?.data?.userName &&
      response?.data?.data?.rtcToken &&
      response?.data?.data?.rtmToken &&
      responseScreen?.status === 200 &&
      isCommonResponseSuccessful(responseScreen?.data?.code) &&
      responseScreen?.data?.data?.userName &&
      responseScreen?.data?.data?.rtcToken &&
      responseScreen?.data?.data?.rtmToken
    ) {
      return {
        success: true,
        mainToken: response.data.data,
        screenToken: responseScreen.data.data,
      }
    }

    return { success: false }
  },

  // Get Agora Chat token
  async getAgoraChatTokens() {
    const response = await getAgoraChatToken()
    
    if (
      response?.status === 200 &&
      isCommonResponseSuccessful(response?.data?.code) &&
      response?.data?.data?.chatToken
    ) {
      return {
        success: true,
        chatToken: response.data.data.chatToken,
      }
    }

    return { success: false }
  },

  // Build RTC props
  buildRtcProps({
    bookedEventId,
    mainToken,
    screenToken,
    userRole,
    eventType,
    userHasAllowedAudio,
    userHasAllowedVideo,
    selectedCamera,
    selectedMicrophone,
  }) {
    let role = 'host'
    
    if (userRole !== 'mentor' && eventType === allAvailableEventTypes.webinar) {
      role = 'audience'
    }

    return {
      appId: import.meta.env.VITE_AGORA_APP_ID,
      channel: bookedEventId,
      uid: parseInt(mainToken.userName),
      token: mainToken.rtcToken,
      enableScreensharing: true,
      screenshareUid: screenToken.userName,
      screenshareToken: screenToken.rtcToken,
      layout: AGORA_RTC_LEGACY_LAYOUT_IDS[AGORA_RTC_LAYOUTS.pin],
      role,
      enableAudio: userHasAllowedAudio,
      enableVideo: userHasAllowedVideo,
      cameraDeviceId: selectedCamera,
      microphoneDeviceId: selectedMicrophone,
    }
  },

  // Build RTM props
  buildRtmProps({
    username,
    mainToken,
    userRole,
  }) {
    return {
      username: username,
      displayUsername: true,
      token: mainToken.rtmToken,
      showPopUpBeforeRemoteMute: false,
      isThisUserAllowedToMuteOthers: userRole === 'mentor' || userRole === 'panelist',
    }
  },

  // Log session events
  logSessionEvent(bookedEventId, eventType, userRole, additionalData = {}) {
    return markBookedEventLog(bookedEventId, eventType, userRole, additionalData)
  },

  // Get correct role ID for logging
  getRoleId(userRole) {
    switch (userRole) {
      case 'mentor':
        return 'mentor'
      case 'panelist':
        return 'panelist'
      default:
        return 'endUser'
    }
  },
}
